module.exports = __webpack_public_path__ + "img/XL_PERSO_LISTE.5b4b5360.svg";